const BUSINESS_TYPES = [
  {
    label: "Zemědělský obchodník / Farma",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Útulek pro zvířata / Charita",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Výkrmna základní",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Producent hovězího masa",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Brojleři", value: "Broilers", id: "broilers" },
  {
    label: "Nákupní skupina",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Produkce telat",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Farma telat / Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Nákupčí dobytka", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Smluvní pěstitel",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Družstvo", value: "Cooperative", id: "cooperative" },
  {
    label: "Korporátní kancelář",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Chov krav s telaty",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Mlékárenská produkce",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Krmiv mlýn", value: "Feed Mill", id: "feed_mill" },
  { label: "Výkrmna", value: "Feedyard", id: "feedyard" },
  {
    label: "Pěstitel / Pěstitelská farma",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Líheň", value: "Hatchery", id: "hatchery" },
  {
    label: "Produkce jalovic",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Integrace nosnic",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Nosnice", value: "Layers", id: "layers" },
  { label: "Média", value: "Media", id: "media" },
  {
    label: "Mlékárenské družstvo / Nákupčí",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Smíšený / Jiný producent",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Dodavatel živin",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Balírna / Zpracovatel",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Maloobchodní prodejna zví řat",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Lékárna", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Chovatel drůbeže",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Integrátor drůbeže",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Producent ovcí", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Skladovací operace",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Tržiště / Prodejní síň",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  {
    label: "Producent vepřového",
    value: "Swine Producer",
    id: "swine_producer",
  },
  { label: "Krůty", value: "Turkeys", id: "turkeys" },
  {
    label: "Univerzita / Vzdělávání",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Veterinární praxe",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Velkoobchod / Maloobchod",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Nákupčí vlny", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Povinné",
    },
  },
  salutation: {
    label: "Oslovení",
    placeholder: "Vyberte oslovení",
    errors: {
      required: "Oslovení je povinné",
      invalid: "Prosím vyberte platné oslovení",
    },
  },
  firstName: {
    label: "Jméno",
    placeholder: "Jan",
    errors: {
      authenticatedNameUpdateTrial:
        "Jste přihlášeni a své jméno nemůžete změnit.",
      required: "Jméno je povinné",
      minLength: "Jméno musí mít alespoň 2 znaky",
      maxLength: "Jméno může mít maximálně 50 znaků",
    },
  },
  lastName: {
    label: "Příjmení",
    placeholder: "Novák",
    errors: {
      authenticatedNameUpdateTrial:
        "Jste přihlášeni a své jméno nemůžete změnit.",
      required: "Příjmení je povinné",
      minLength: "Příjmení musí mít alespoň 2 znaky",
      maxLength: "Příjmení může mít maximálně 50 znaků",
    },
  },
  email: {
    label: "E-mail",
    placeholder: "jan.novak@example.org",
    description:
      "Zadejte prosím osobní e-mailovou adresu, ne sdílenou e-mailovou adresu.",
    prefixWarningTitle: "Detekována sdílená schránka",
    prefixWarningDescription:
      "Doporučujeme použít osobní e-mailovou adresu pro lepší personalizované zkušenosti",
    errors: {
      authenticatedEmailUpdateTrial:
        "Jste přihlášeni a svou e-mailovou adresu nemůžete změnit.",
      required: "E-mail je povinný",
      invalidEmail: "Zadejte prosím platnou e-mailovou adresu",
      emailAssociatedWithYourAccount:
        "Vaše e-mailová adresa je spojena s vaším účtem a nemůže být změněna.",
    },
  },
  confirmEmail: {
    label: "Potvrdit e-mail",
    placeholder: "jan.novak@example.org",
    errors: {
      authenticatedEmailUpdateTrial:
        "Jste přihlášeni a svou e-mailovou adresu nemůžete změnit.",
      required: "Potvrzení e-mailu je povinné",
      invalidEmail: "Zadejte prosím platnou e-mailovou adresu",
      emailMatchError: "E-mailové adresy se neshodují",
    },
  },
  password: {
    label: "Heslo",
    placeholder: "Zadejte své heslo",
    errors: {
      required: "Heslo je povinné",
    },
  },
  confirmPassword: {
    label: "Potvrdit heslo",
    placeholder: "Potvrďte své heslo",
    errors: {
      required: "Potvrzení hesla je povinné",
      passwordMatchError: "Hesla se neshodují",
    },
  },
  addressLine1: {
    label: "Adresa řádek 1",
    placeholder: "Hlavní 123",
    errors: {
      required: "Adresa řádek 1 je povinná",
      minLength: "Adresa řádek 1 musí mít alespoň 5 znaků",
      maxLength: "Adresa řádek 1 může mít maximálně 100 znaků",
    },
  },
  addressLine2: {
    label: "Adresa řádek 2",
    placeholder: "Byt 4B",
    errors: {
      required: "Adresa řádek 2 je povinná",
      maxLength: "Adresa řádek 2 může mít maximálně 100 znaků",
    },
  },
  city: {
    label: "Město / Obec",
    placeholder: "Praha",
    errors: {
      required: "Město / Obec je povinné",
      minLength: "Město / Obec musí mít alespoň 2 znaky",
      maxLength: "Město / Obec může mít maximálně 50 znaků",
    },
  },
  country: {
    label: "Země",
    placeholder: "Vyberte zemi",
    errors: {
      required: "Země je povinná",
      invalid: "Vyberte prosím platnou zemi",
    },
  },
  state: {
    label: "Kraj",
    placeholder: "Vyberte kraj",
    errors: {
      required: "Kraj je povinný",
      invalid: "Prosím vyberte platný kraj",
    },
  },
  jurisdiction: {
    label: "Jurisdikce licence",
    placeholder: "Vyberte jurisdikci licence",
    errors: {
      required: "Jurisdikce licence je povinná",
      invalid: "Prosím vyberte platnou jurisdikci",
    },
  },
  zipCode: {
    label: "PSČ",
    placeholder: "110 00",
    errors: {
      required: "PSČ je povinné",
      invalid: "Zadejte prosím platné PSČ",
    },
  },
  role: {
    label: "Role",
    placeholder: "Vyberte svou roli",
    errors: {
      required: "Prosím vyberte svou roli",
      invalid: "Prosím vyberte platnou roli",
    },
  },
  businessType: {
    label: "Typ podnikání",
    placeholder: "Vyberte typ podnikání",
    errors: {
      required: "Typ podnikání je povinný",
      invalid: "Prosím vyberte platný typ podnikání",
    },
  },
  businessName: {
    label: "Název firmy",
    placeholder: "Zadejte název firmy",
    errors: {
      required: "Název firmy je povinný",
      minLength: "Název firmy musí mít alespoň 2 znaky",
      maxLength: "Název firmy může mít maximálně 100 znaků",
    },
  },
  businessSearch: {
    label: "Vyhledávání firmy:",
    addNewAccount: "Přidat nový firemní účet",
    canNotFindBusiness: "Nemůžete najít svou firmu?",
    guideline: "Zadejte prosím své PSČ a poté vyberte ze seznamu níže.",
    guidelineForNameSearch:
      "Zadejte prosím celý název firmy a poté vyberte ze seznamu.",
    placeholder: "Kde pracujete?",
    noResults: "Nebyly nalezeny žádné výsledky",
    searching: "Vyhledávání...",
    selectedBusinessHeading: "Vybraná firma:",
    selectedBusinessNotCorrect: "Není správné?",
    selectedBusinessTryAgain: "Zkusit znovu",
    selectedBusinessDismiss: "Zrušit firmu",
    resultsFound: {
      singular: "Nalezena 1 firma",
      plural: "Nalezeno více firem",
    },
    errors: {
      network:
        "Máme problémy s připojením k vyhledávači firem. Zkuste to prosím později.",
    },
  },
  explicitConsent: {
    label:
      "Zaškrtnutím tohoto políčka souhlasím se zasíláním marketingových sdělení od společnosti Elanco.",
    errors: {
      required: "Je nutný souhlas",
    },
  },
  explicitSmsConsent: {
    label:
      "Zaškrtnutím tohoto políčka souhlasím se zasíláním marketingových sdělení od společnosti Elanco prostřednictvím SMS/textových zpráv.",
    errors: {
      required: "Souhlas se zasíláním SMS je povinný",
    },
  },
  telephone: {
    label: "Osobní telefon",
    placeholder: "Zadejte svůj osobní telefon",
    dialCodeLabel: "Kód",
    dialCodePlaceholder: "Hledat zemi…",
    errors: {
      invalid: "Zadejte prosím platné telefonní číslo.",
    },
  },
  businessTelephone: {
    label: "Firemní telefon",
    placeholder: "Zadejte svůj firemní telefon",
    dialCodeLabel: "Kód",
    dialCodePlaceholder: "Hledat zemi…",
    errors: {
      invalid: "Zadejte prosím platné telefonní číslo.",
    },
  },
  professionalNumber: {
    label: "Profesní číslo",
    placeholder: "1234567",
    errors: {
      required: "Zadejte prosím profesní číslo",
      maxLength: "Vstup přesahuje limit znaků",
    },
  },
  addressSearch: {
    errors: {
      required: "Toto pole je povinné",
    },
  },
  businessSearchField: {
    errors: {
      required: "Toto pole je povinné",
    },
  },
  checkbox: {
    errors: {
      required: "Toto pole je povinné",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Toto pole je povinné",
    },
  },
  combobox: {
    errors: {
      required: "Toto pole je povinné",
    },
  },
  datePicker: {
    errors: {
      required: "Toto pole je povinné",
    },
  },
  dateRange: {
    errors: {
      required: "Toto pole je povinné",
    },
  },
  dateTime: {
    errors: {
      required: "Toto pole je povinné",
    },
  },
  emailField: {
    errors: {
      required: "Toto pole je povinné",
    },
  },
  fileInput: {
    errors: {
      required: "Prosím vyberte soubor",
    },
  },
  number: {
    errors: {
      required: "Zadejte prosím číslo",
      minValue: "Zadejte prosím hodnotu vyšší než minimum",
      maxValue: "Zadejte prosím hodnotu nižší než maximum",
    },
  },
  passwordField: {
    errors: {
      required: "Toto pole je povinné",
    },
  },
  rangeSlider: {
    errors: {
      required: "Toto pole je povinné",
    },
  },
  select: {
    errors: {
      required: "Toto pole je povinné",
    },
  },
  telephoneField: {
    errors: {
      required: "Zadávejte prosím pouze čísla",
      invalidTelephone: "Zadejte prosím platné telefonní číslo",
      invalidFormat: "Neplatný formát čísla",
    },
  },
  text: {
    errors: {
      required:
        "Používejte prosím pouze písmena (A-Z), čísla (0-9) a bez symbolů",
      maxLength: "Vstup přesahuje limit znaků",
      minLength: "Vstup musí mít alespoň 2 znaky",
    },
  },
  textarea: {
    characters: "znaků",
  },
  time: {
    errors: {
      required: "Toto pole je povinné",
    },
  },
  form: {
    errors: {
      generic: "Při odesílání formuláře došlo k chybě. Zkuste to prosím znovu.",
      reportAnIssue: "Nahlaste prosím problém.",
      configuration: "Chyba konfigurace",
      noFormQuestionsAvailable: "Nejsou k dispozici žádné otázky formuláře.",
      formComponentLoad:
        "Komponentu formuláře nelze načíst kvůli nepodporovanému poli.",
      code: "Kód",
      type: "Typ",
      missingRequiredFields:
        "V tomto formuláři chybí povinná pole (E-mail a/nebo Souhlas). Kontaktujte prosím správce pro opravu konfigurace formuláře.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Akademik", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Ochrana zvířat - Jiné",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Ochrana zvířat - Maloobchodní personál",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Ochrana zvířat - Veterinář",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Ochrana zvířat - Veterinární sestra",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Ochrana zvířat - Dobrovolník",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Rozšíření pro hovězí / výkrm",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Producent hovězího masa",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Chovatel", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Obchodní administrátor / Recepční",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Vlastník firmy / Partner",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Konzultant pro výživu",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Korporátní veterinární zaměstnanec (mimo nemocnici)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Mlékárenský producent",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Zástupce distributora, Terenní",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Zástupce distributora, Kancelářský",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Vzdělávací instituce - Student střední školy",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Vzdělávací instituce - Student TAFE",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Vzdělávací instituce - Vysokoškolský student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Kadeřník pro zvířata", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Ředitel lékařské / kliniky",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Prodej výživy / krmiv",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Odborník na výživu",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutricionista", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Kancelářský / Manažer praxe",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC prodejce", id: "otc_retailer" },
  { value: "Pharmacist", label: "Lékárník", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Lékárna - Personál",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Producent vepřů", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Producent drůbeže",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Vlastník praxe, Ne-DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Recepční / Zákaznický servis",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Prodejna distributora - Personál",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Výrobce - smíšený/jiný",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Maloobchodník",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Chovatel ovcí",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Veterinář",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trenér", id: "trainer" },
  { value: "Veterinarian", label: "Veterinář", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Veterinář, Vlastník praxe",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Veterinární asistent",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinární sestra",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Veterinární praxe - Jiné",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Veterinární praxe - Veterinář",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Veterinární praxe - Veterinární sestra",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Veterinární specialista",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Student veteriny",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Veterinární chirurg",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinární technik",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Velkoobchodník", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Pan",
    value: "M.",
    id: "m",
  },
  {
    label: "Slečna",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Pan",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Paní",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Paní",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Profesor",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
